import { FlashMessage } from '@pegasus/ui-flashmessages';
import { CENTRAL_API_PREFIX } from 'src/shared/constants';
import { assertStatusCode, createRestClient } from '../restClient';

export interface Response {
    results: FlashMessage[];
}

const client = createRestClient(CENTRAL_API_PREFIX, '/flash-messenger');

export const fetchFlashMessages = (): Promise<Response> => {
    return client
        .get(`/clients/me/messages`)
        .then(assertStatusCode([200]))
        .then(response => response.json())
        .then((data: { results?: FlashMessage[] }) => {
            if (data && data.results && data.results.length) {
                client.delete(`/clients/me/messages`);
            }
            return data.results || [];
        })
        .catch(_ => [] as FlashMessage[])
        .then(messages => ({
            results: messages,
        }));
};
